import React, { FC } from "react";
import ABadge, { BadgeProps } from '@atlaskit/badge';

export const Badge: FC<BadgeProps> = (props) => (
  <ABadge {...props} />
);

export type {
  BadgeProps
};